import {DealSensitivityCompact} from "./deal-sensitivity-compact";

export interface DealSensitivityOverview {
    dealId?: number;
    outdated?: boolean;
    dealSensitivities?: DealSensitivityCompact[];
    lastUsedStep?: number;
    lastUsedSteps?: number;
    lastUsedParamType?: "DISCOUNT_RATE_DELTA" | "EXIT_MULTIPLE_DELTA" | "TIMING_IN_QTRS_DELTA" | "UNDRAWN_MULTIPLE_DELTA";
}

export const EMPTY_DEAL_SENSITIVITY_OVERVIEW: DealSensitivityOverview = {
    dealId: undefined,
    outdated: undefined,
    dealSensitivities: [],
    lastUsedStep: undefined,
    lastUsedSteps: undefined,
    lastUsedParamType: undefined,
};
